import { Typography, useTheme } from '@mui/material'
import React from 'react'
const TypographyPrimary = ({ text, fontSize }) => {
  const theme = useTheme()
  return <Typography sx={{ color: theme.palette.text.primary, fontSize: fontSize ?? 14 }}>{text}</Typography>
}

export default TypographyPrimary
